if (!customElements.get('harmonica-shoe-filters')) {
  customElements.define('harmonica-shoe-filters', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      const source = this.querySelector('[data-products]');
      if (!source) return;
      this.initialized = true;
      this.products = JSON.parse(source.textContent);
      this.size = this.querySelector('[data-size]');
      this.colour = this.querySelector('[data-colour]');
      this.stock = this.querySelector('[data-stock]');
      this.products.forEach(product => {
        product.sizeIndex = product.options.findIndex(name => /size/i.test(name));
        product.colourIndex = product.options.findIndex(name => /colou?r/i.test(name));
      });
      this.normalizeSize = value => String(value).replace(/^US\s*/i, '').trim();
      const populate = (select, indexKey) => {
        const values = new Set();
        this.products.forEach(product => {
          if (product[indexKey] >= 0) product.variants.forEach(variant => values.add(indexKey === 'sizeIndex' ? this.normalizeSize(variant.options[product[indexKey]]) : variant.options[product[indexKey]]));
          else if (indexKey === 'colourIndex' && product.colour) values.add(product.colour);
        });
        [...values].sort((a, b) => a.localeCompare(b, undefined, {numeric:true})).forEach(value => select.add(new Option(value, value)));
      };
      populate(this.size, 'sizeIndex');
      populate(this.colour, 'colourIndex');
      this.addEventListener('change', () => this.apply());
      this.querySelector('[data-clear]').addEventListener('click', () => {
        this.size.value = this.colour.value = '';
        this.stock.checked = false;
        this.apply();
      });
      this.hidden = false;
      requestAnimationFrame(() => this.apply());
      const section = this.closest('.js-collection');
      if (section) {
        this.observer = new MutationObserver(records => {
          if (records.some(record => [...record.addedNodes, ...record.removedNodes].some(node =>
            node.nodeType === 1 && (node.matches('.collection__item, .js-grid-wrapper') || node.querySelector('.collection__item'))
          ))) requestAnimationFrame(() => this.apply());
        });
        this.observer.observe(section, {childList:true, subtree:true});
      }
    }
    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }
    apply() {
      const section = this.closest('.js-collection');
      if (!section) return;
      let visible = 0;
      const sort = new URLSearchParams(location.search).get('sort_by');
      const explicitSort = sort && sort !== 'manual';
      const selected = Boolean(this.size.value || this.colour.value || this.stock.checked);
      section.querySelectorAll('.collection__item[data-hm-handle]').forEach(card => {
        const product = this.products.find(item => item.handle === card.dataset.hmHandle);
        if (!product) return;
        const match = !selected || product.variants.some(variant =>
          (!this.size.value || this.normalizeSize(variant.options[product.sizeIndex]) === this.size.value) &&
          (!this.colour.value || (product.colourIndex >= 0 ? variant.options[product.colourIndex] : product.colour) === this.colour.value) &&
          (this.stock.checked ? variant.stock : variant.available)
        );
        card.toggleAttribute('data-hm-hidden', !match);
        card.style.order = explicitSort ? '' : product.variants.some(variant => variant.stock) ? '0' : '1';
        if (match) visible++;
      });
      const count = this.querySelector('[data-count]');
      count.textContent = visible + ' ' + count.dataset.label;
      this.querySelector('[data-empty]').hidden = visible !== 0;
    }
  });
}
